module.exports = __webpack_public_path__ + "media/images/tibiacoins-seo_logo-7fb0813af4712c95e339b027afcce387.png";